import axios from 'axios'

import {
  Message
} from 'element-ui'
import router from '../router/index'
// import router_ from '@/router'
// import store from '@/store'
// import domMessage from './messageOnce'
// const messageOnce = new domMessage()
import Vue from "vue";

const service = axios.create({
  // baseURL: "http://192.168.66.99:8600",
  // baseURL: "http://192.168.100.214:8600",
  // 13684832366
  baseURL: window.location.origin + '/api',
  // baseURL: "https://chatlearning.newacademic.net/api",
  timeout: 50000, // 请求超时时间

})

service.interceptors.request.use((config) => {
  config.headers['token'] = localStorage.getItem("tokenChat"),
    config.headers.common = {
      // Authorization: 'Bearer ' + store.getCookie("Chat_token")
      // token: 'eyJraWQiOiJadmt6U1dwSDFiIiwiYWxnIjoiRVMyNTZLIn0.eyJpc3MiOiJjaGF0LWxlYXJuaW5nLWFwcCIsInN1YiI6InVzZXIiLCJkYXRhIjp7InVzZXJJZCI6Mn0sImV4cCI6MTcwNzQ2NTA3NCwianRpIjoiWnZrelNXcEgxYiJ9.ySjhlahxJ8_HkmA9Nb17GsGsl8f9ByNPYEVHLTGMDCkeGCgBafDAg_XNENxqfUiqyOSV4XNIs4P9niNY_2yO6Q',

    }
  return config
}, (err) => {
  // console.log('a1')
  return Promise.reject(err)
})

service.interceptors.response.use((res) => {
  const response = res.data
  if (response.code == 200) {
    return res
  } else if (response.code == 0) {
    return response
  } else if (res.data.data) {
    return res.data
  } else {
    if (res.data.code == 1010) {
      router.push({
        name: "home",
      });
    } else {
      if (res.data.msg) {
        Message.error({
          message: res.data.msg,
          type: 'error'
        })
      }


      return res
    }

    // return Promise.reject(new Error(response.message || 'Error'))
  }
}, (err) => {
  // console.log('a',err)
  return Promise.reject(err)
})

export default service